import React, { useState, useEffect } from 'react';
import { urlApiProd } from '../utiles';

function EditarProducto({ producto, cerrar, guardar, opciones, medidas }) {
    const [botonDeshabilitado, setBotonDeshabilitado] = useState(false);
    const [categoria, setCategoria] = useState(producto.categoria || '');
    const [especie, setEspecie] = useState(producto.especie || '');
    const [ncm, setNcm] = useState(producto.ncm || '');
    const [medida, setMedida] = useState(producto.medida || '');
    const [espesor, setEspesor] = useState(producto.espesor || '');
    const [idCalidad, setIdCalidad] = useState(producto.id_calidad || '');

    const [espesoresDisponibles, setEspesoresDisponibles] = useState([]);

    useEffect(() => {
        if (medida) {
            const medidaSeleccionada = medidas.find(m => m.id_medida === parseInt(medida));
            if (medidaSeleccionada && medidaSeleccionada.espesor) {
                setEspesoresDisponibles(medidaSeleccionada.espesor);
            } else {
                setEspesoresDisponibles([]);
            }
        }
    }, [medida, medidas]);

    const handleSubmit = (event) => {
        event.preventDefault();
        setBotonDeshabilitado(true);

        const editedProducto = {
            id_producto: producto.id_producto,
            categoria: parseInt(categoria),
            especie: parseInt(especie),
            ncm,
            medida: parseInt(medida),
            espesor: parseFloat(espesor),
            id_calidad: parseInt(idCalidad)
        };

        guardar(editedProducto);
    };

    return (
        <div className='modal-overlay'>
            <div className='modal1'>
                <div className='card'>
                    <form onSubmit={handleSubmit}>
                        <div className='card-header'>
                            <h3 className='card-title' style={{ textAlign: 'center' }}>Editar Producto</h3>
                        </div>
                        <div className='card-body'>
                            <div className='input-group mb-3'>
                                <span className='input-group-text'>Categoría</span>
                                <select
                                    className="form-control"
                                    value={categoria}
                                    onChange={(e) => setCategoria(e.target.value)}
                                    required
                                >
                                    <option value="">Seleccionar Categoría</option>
                                    {opciones.categorias.map(cat => (
                                        <option key={cat.id_categoria} value={cat.id_categoria}>{cat.nombre}</option>
                                    ))}
                                </select>
                            </div>

                            <div className='input-group mb-3'>
                                <span className='input-group-text'>Especie</span>
                                <select
                                    className="form-control"
                                    value={especie}
                                    onChange={(e) => setEspecie(e.target.value)}
                                    required
                                >
                                    <option value="">Seleccionar Especie</option>
                                    {opciones.especies.map(esp => (
                                        <option key={esp.id_especie} value={esp.id_especie}>{esp.nombre}</option>
                                    ))}
                                </select>
                            </div>

                            <div className='input-group mb-3'>
                                <span className='input-group-text'>NCM</span>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={ncm}
                                    onChange={(e) => setNcm(e.target.value)}
                                    required
                                />
                            </div>

                            <div className='input-group mb-3'>
                                <span className='input-group-text'>Medida</span>
                                <select
                                    className="form-control"
                                    value={medida}
                                    onChange={(e) => setMedida(e.target.value)}
                                    required
                                >
                                    <option value="">Seleccionar Medida</option>
                                    {opciones.medidas.map(m => (
                                        <option key={m.id_medida} value={m.id_medida}>{m.medida}</option>
                                    ))}
                                </select>
                            </div>

                            {medida && (
                                <div className='input-group mb-3'>
                                    <span className='input-group-text'>Espesor</span>
                                    <select
                                        className="form-control"
                                        value={espesor}
                                        onChange={(e) => setEspesor(e.target.value)}
                                        required
                                    >
                                        <option value="">Seleccionar Espesor</option>
                                        {espesoresDisponibles.map((e, index) => (
                                            <option key={index} value={e}>{e}</option>
                                        ))}
                                    </select>
                                </div>
                            )}

                            <div className='input-group mb-3'>
                                <span className='input-group-text'>Calidad</span>
                                <select
                                    className="form-control"
                                    value={idCalidad}
                                    onChange={(e) => setIdCalidad(e.target.value)}
                                    required
                                >
                                    <option value="">Seleccionar Calidad</option>
                                    {opciones.calidades.map(c => (
                                        <option key={c.id_calidad} value={c.id_calidad}>{c.calidad}</option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        <div className='card-footer' style={{ textAlign: 'center' }}>
                            <button type="submit" className="btn btn-outline-success mb-3 mt-3" disabled={botonDeshabilitado}>Guardar</button>
                            <button type="button" className="btn btn-outline-danger" onClick={cerrar}>Cancelar</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default EditarProducto;
